// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.shareIssue_page__38TEH {
  height: 100vh;
  min-height: 100vh;
  background: var(--bg-base);
  color: var(--text-primary);
  font-family: "Inter", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ─── Top navigation bar ─── */
.shareIssue_navbar__8\\+j\\+y {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 0 20px;
  background: var(--bg-topbar);
  border-bottom: 1px solid var(--border-subtle);
  backdrop-filter: blur(12px);
  font-size: 13px;
  color: var(--text-tertiary);
  overflow: hidden;
  white-space: nowrap;
}

.shareIssue_navTeam__iE2sb {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-tertiary);
  flex-shrink: 0;
}

.shareIssue_navTeamIcon__fMOAd {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}

.shareIssue_navSep__Tc7Nd {
  color: var(--border-focus);
  margin: 0 2px;
  flex-shrink: 0;
}

.shareIssue_navIssue__Pzd3h {
  color: var(--text-strong);
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── Main content area ─── */
.shareIssue_layout__-zE\\+S {
  display: flex;
  max-width: 1060px;
  margin: 0 auto;
  height: calc(100vh - 44px);
  overflow: hidden;
}

.shareIssue_container__x2NPe {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  padding: 32px 40px 64px;
}
@media (max-width: 800px) {
  .shareIssue_container__x2NPe {
    height: auto;
    overflow: auto;
    padding: 24px 20px 48px;
  }
}

/* ─── Properties sidebar ─── */
.shareIssue_sidebar__xhTqF {
  width: 260px;
  flex-shrink: 0;
  height: 100%;
  border-left: 1px solid var(--border-subtle);
  padding: 32px 24px 48px;
}
@media (max-width: 860px) {
  .shareIssue_sidebar__xhTqF {
    display: none;
  }
}

.shareIssue_sidebarGroup__j3iW- {
  margin-bottom: 24px;
}

.shareIssue_sidebarGroupTitle__dQJAj {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-faint);
  margin-bottom: 12px;
}

.shareIssue_propertyList__FL\\+0J {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.shareIssue_propertyRow__D71pa {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.shareIssue_propertyIcon__tRbg8 {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
}

.shareIssue_propertyValue__ncMOJ {
  color: var(--text-strong);
}

.shareIssue_propertyMuted__F-xjX {
  color: var(--text-faint);
}

.shareIssue_labelList__wIaFv {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.shareIssue_labelChip__muz\\+j {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-strong);
  background: var(--fill-default);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  padding: 3px 10px 3px 7px;
}

.shareIssue_labelDot__ZJdbs {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ─── Issue header ─── */
.shareIssue_issueHeader__nU1xQ {
  margin-bottom: 24px;
}

.shareIssue_identifierRow__I4fOT {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.shareIssue_identifier__R6QsN {
  font-size: 13px;
  color: var(--text-tertiary);
  font-weight: 500;
  letter-spacing: 0.01em;
}

.shareIssue_stateBadge__VnQ50 {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--fill-default);
}

.shareIssue_stateDot__JIZaN {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.shareIssue_issueTitle__WFekp {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: -0.01em;
}

.shareIssue_metaRow__845YN {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
  font-size: 12px;
  color: var(--text-faint);
}

.shareIssue_metaItem__4HwQ3 {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* ─── Sections ─── */
.shareIssue_divider__4QlJx {
  border: 0;
  border-top: 1px solid var(--border-subtle);
  margin: 0;
}

.shareIssue_section__R5CCQ {
  padding: 24px 0;
}

.shareIssue_sectionLabel__pqD3M {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-faint);
  margin-bottom: 16px;
}

/* ─── Description (markdown body) ─── */
.shareIssue_description__OGKiq {
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-body);
}
.shareIssue_description__OGKiq p {
  margin: 0 0 0.75em;
}
.shareIssue_description__OGKiq p:last-child {
  margin-bottom: 0;
}
.shareIssue_description__OGKiq strong {
  color: var(--text-heading);
  font-weight: 600;
}
.shareIssue_description__OGKiq ul,
.shareIssue_description__OGKiq ol {
  margin: 0.5em 0 0.75em 1.4em;
  padding: 0;
}
.shareIssue_description__OGKiq li {
  margin: 0.2em 0;
}
.shareIssue_description__OGKiq a {
  color: var(--color-link);
  text-decoration: none;
}
.shareIssue_description__OGKiq a:hover {
  text-decoration: underline;
}
.shareIssue_description__OGKiq hr {
  border: 0;
  border-top: 1px solid var(--border-default);
  margin: 1em 0;
}
.shareIssue_description__OGKiq blockquote {
  margin: 0.75em 0;
  padding: 0 0 0 12px;
  border-left: 3px solid var(--border-medium);
  color: var(--text-secondary);
}
.shareIssue_description__OGKiq code {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace;
  font-size: 0.9em;
  background: var(--fill-default);
  border: 1px solid var(--border-default);
  padding: 0.15em 0.35em;
  border-radius: 4px;
  color: var(--text-strong);
}
.shareIssue_description__OGKiq pre {
  margin: 0.75em 0;
  border-radius: 6px;
  overflow-x: auto;
  white-space: pre;
}
.shareIssue_description__OGKiq pre code {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 13px;
  color: var(--text-body);
}
.shareIssue_description__OGKiq img {
  display: block;
  max-width: 100%;
  max-height: 60vh;
  border-radius: 6px;
  margin: 0.5em auto;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.15s;
}
.shareIssue_description__OGKiq img:hover {
  opacity: 0.85;
}
.shareIssue_description__OGKiq h1,
.shareIssue_description__OGKiq h2,
.shareIssue_description__OGKiq h3,
.shareIssue_description__OGKiq h4,
.shareIssue_description__OGKiq h5,
.shareIssue_description__OGKiq h6 {
  color: var(--text-heading);
  margin: 1.2em 0 0.4em;
  line-height: 1.3;
}
.shareIssue_description__OGKiq h1 {
  font-size: 1.3em;
}
.shareIssue_description__OGKiq h2 {
  font-size: 1.15em;
}
.shareIssue_description__OGKiq h3 {
  font-size: 1.05em;
}
.shareIssue_description__OGKiq table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.75em 0;
  font-size: 13px;
}
.shareIssue_description__OGKiq table th,
.shareIssue_description__OGKiq table td {
  padding: 6px 10px;
  border: 1px solid var(--border-default);
  text-align: left;
}
.shareIssue_description__OGKiq table th {
  background: var(--fill-subtle);
  font-weight: 600;
  color: var(--text-muted);
}

.shareIssue_emptyState__eTzdk {
  color: var(--text-faint);
  font-size: 14px;
}

/* ─── Comments ─── */
.shareIssue_comments__FW7kb {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.shareIssue_comment__4hbU7 {
  padding: 16px 0;
  border-bottom: 1px solid var(--border-subtle);
}
.shareIssue_comment__4hbU7:last-child {
  border-bottom: none;
}

.shareIssue_commentHeader__r7xC6 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.shareIssue_commentAvatar__xORY3 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--fill-active);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  flex-shrink: 0;
}

.shareIssue_commentAuthor__JGZbT {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.shareIssue_commentTime__3iDF6 {
  font-size: 12px;
  color: var(--text-faint);
  margin-left: auto;
}

.shareIssue_commentBody__QtY2V {
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-body);
  padding-left: 34px;
}
.shareIssue_commentBody__QtY2V p {
  margin: 0 0 0.5em;
}
.shareIssue_commentBody__QtY2V p:last-child {
  margin-bottom: 0;
}
.shareIssue_commentBody__QtY2V a {
  color: var(--color-link);
  text-decoration: none;
}
.shareIssue_commentBody__QtY2V a:hover {
  text-decoration: underline;
}
.shareIssue_commentBody__QtY2V code {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace;
  font-size: 0.9em;
  background: var(--fill-default);
  border: 1px solid var(--border-default);
  padding: 0.15em 0.35em;
  border-radius: 4px;
}
.shareIssue_commentBody__QtY2V pre {
  margin: 0.5em 0;
  padding: 12px 16px;
  background: var(--bg-code-block);
  border: 1px solid var(--border-subtle);
  border-radius: 6px;
  overflow-x: auto;
}
.shareIssue_commentBody__QtY2V pre code {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 13px;
}
.shareIssue_commentBody__QtY2V blockquote {
  margin: 0.5em 0;
  padding-left: 12px;
  border-left: 3px solid var(--border-medium);
  color: var(--text-secondary);
}
.shareIssue_commentBody__QtY2V img {
  display: block;
  max-width: 100%;
  max-height: 60vh;
  border-radius: 6px;
  margin: 0.5em auto;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.15s;
}
.shareIssue_commentBody__QtY2V img:hover {
  opacity: 0.85;
}

.shareIssue_composer__ySU-N {
  margin-top: 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.shareIssue_composerInput__NOZfz {
  align-self: stretch;
  width: 100%;
  resize: none;
  min-height: 80px;
  background: var(--fill-default);
  border: none;
  border-radius: 10px;
  padding: 12px;
  color: var(--text-strong);
  font-size: 14px;
  outline: none;
  margin-bottom: 10px;
}

.shareIssue_composerInput__NOZfz:focus {
  box-shadow: 0 0 0 1px var(--border-strong) inset;
}

/* ─── Image lightbox ─── */
.shareIssue_lightboxOverlay__6frl3 {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: var(--bg-lightbox);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
  animation: shareIssue_fadeIn__2Bib2 0.15s ease-out;
}

@keyframes shareIssue_fadeIn__2Bib2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.shareIssue_lightboxContent__xpZZF {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.shareIssue_lightboxImg__eVxVR {
  max-width: 94vw;
  max-height: 94vh;
  object-fit: contain;
  border-radius: 6px;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
  transform-origin: center center;
  transition: transform 0.15s ease-out;
  cursor: grab;
}
.shareIssue_lightboxImg__eVxVR:active {
  cursor: grabbing;
}

.shareIssue_lightboxClose__Ca2Dy {
  position: fixed;
  top: 16px;
  right: 20px;
  z-index: 110;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--fill-active);
  color: var(--text-strong);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.shareIssue_lightboxClose__Ca2Dy:hover {
  background: var(--border-focus);
}

.shareIssue_lightboxZoomHint__7Rztp {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 110;
  font-size: 12px;
  color: var(--text-faint);
  background: var(--bg-backdrop);
  padding: 6px 14px;
  border-radius: 20px;
  pointer-events: none;
  white-space: nowrap;
}

/* ─── Loading & error states ─── */
.shareIssue_loadingPage__ix3kn {
  min-height: 100vh;
  background: var(--bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
}

.shareIssue_spinner__cA47q {
  width: 32px;
  height: 32px;
  border: 2.5px solid var(--border-default);
  border-radius: 50%;
  border-top-color: var(--color-link);
  animation: shareIssue_spin__HVGP3 0.9s ease-in-out infinite;
}

@keyframes shareIssue_spin__HVGP3 {
  to {
    transform: rotate(360deg);
  }
}
.shareIssue_errorPage__-aZh0 {
  min-height: 100vh;
  background: var(--bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-tertiary);
  font-size: 14px;
  font-family: "Inter", ui-sans-serif, system-ui, -apple-system, sans-serif;
  padding: 24px;
  text-align: center;
}

.shareIssue_errorBox__WdjSG {
  max-width: 400px;
}

.shareIssue_errorIcon__X9H45 {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.shareIssue_errorText__6HJvo {
  color: var(--text-secondary);
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/shareIssue.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,iBAAA;EACA,0BAAA;EACA,0BAAA;EAEA,+GACE;EASF,mCAAA;EACA,kCAAA;AARF;;AAWA,+BAAA;AAEA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,6CAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AATF;;AAYA;EACE,0BAAA;EACA,aAAA;EACA,cAAA;AATF;;AAYA;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;AATF;;AAYA,8BAAA;AAEA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AAVF;;AAaA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACF,gBAAA;EACE,uBAAA;AAVF;AAYE;EAPF;IAQI,YAAA;IACA,cAAA;IACA,uBAAA;EATF;AACF;;AAYA,+BAAA;AAEA;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,2CAAA;EACA,uBAAA;AAVF;AAYE;EAPF;IAQI,aAAA;EATF;AACF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,uCAAA;EACA,mBAAA;EACA,yBAAA;AATF;;AAYA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AATF;;AAYA,yBAAA;AAEA;EACE,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AAVF;;AAaA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,SAAA;EACA,uBAAA;AAVF;;AAaA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAVF;;AAaA,qBAAA;AAEA;EACE,SAAA;EACA,0CAAA;EACA,SAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;AAXF;;AAcA,wCAAA;AAEA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAZF;AAcE;EACE,kBAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAgBE;EACE,0BAAA;EACA,gBAAA;AAdJ;AAiBE;;EAEE,4BAAA;EACA,UAAA;AAfJ;AAkBE;EACE,eAAA;AAhBJ;AAmBE;EACE,wBAAA;EACA,qBAAA;AAjBJ;AAmBI;EACE,0BAAA;AAjBN;AAqBE;EACE,SAAA;EACA,2CAAA;EACA,aAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,4BAAA;AApBJ;AAuBE;EACE,wFACE;EAEF,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxBJ;AA0BI;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;AAxBN;AA4BE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA1BJ;AA4BI;EACE,aAAA;AA1BN;AA8BE;;;;;;EAME,0BAAA;EACA,qBAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,gBAAA;AA7BJ;AA+BE;EACE,iBAAA;AA7BJ;AA+BE;EACE,iBAAA;AA7BJ;AAgCE;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AA9BJ;AAgCI;;EAEE,iBAAA;EACA,uCAAA;EACA,gBAAA;AA9BN;AAiCI;EACE,8BAAA;EACA,gBAAA;EACA,wBAAA;AA/BN;;AAoCA;EACE,wBAAA;EACA,eAAA;AAjCF;;AAoCA,qBAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,6CAAA;AAlCF;AAoCE;EACE,mBAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,wBAAA;EACA,iBAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAnCF;AAqCE;EACE,iBAAA;AAnCJ;AAsCE;EACE,gBAAA;AApCJ;AAuCE;EACE,wBAAA;EACA,qBAAA;AArCJ;AAuCI;EACE,0BAAA;AArCN;AAyCE;EACE,wFACE;EAEF,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,sBAAA;EACA,kBAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AA1CJ;AA4CI;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AA1CN;AA8CE;EACE,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,4BAAA;AA5CJ;AA+CE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA7CJ;AA+CI;EACE,aAAA;AA7CN;;AAkDA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AA/CF;;AAkDA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA/CF;;AAkDA;EACE,gDAAA;AA/CF;;AAkDA,2BAAA;AAEA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kDAAA;AAhDF;;AAmDA;EACE;IACE,UAAA;EAhDF;EAkDA;IACE,UAAA;EAhDF;AACF;AAmDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAjDF;;AAoDA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,+BAAA;EACA,oCAAA;EACA,YAAA;AAjDF;AAmDE;EACE,gBAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AAlDF;AAoDE;EACE,+BAAA;AAlDJ;;AAsDA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAnDF;;AAsDA,mCAAA;AAEA;EACE,iBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApDF;;AAuDA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,mCAAA;EACA,2DAAA;AApDF;;AAuDA;EACE;IACE,yBAAA;EApDF;AACF;AAuDA;EACE,iBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,yEACE;EAKF,aAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,gBAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AA1DF;;AA6DA;EACE,4BAAA;EACA,gBAAA;AA1DF","sourcesContent":[".page {\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--bg-base);\n  color: var(--text-primary);\n  // overflow: hidden;\n  font-family:\n    \"Inter\",\n    ui-sans-serif,\n    system-ui,\n    -apple-system,\n    \"Segoe UI\",\n    Roboto,\n    Helvetica,\n    Arial,\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ─── Top navigation bar ─── */\n\n.navbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 44px;\n  padding: 0 20px;\n  background: var(--bg-topbar);\n  border-bottom: 1px solid var(--border-subtle);\n  backdrop-filter: blur(12px);\n  font-size: 13px;\n  color: var(--text-tertiary);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.navTeam {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n}\n\n.navTeamIcon {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.navSep {\n  color: var(--border-focus);\n  margin: 0 2px;\n  flex-shrink: 0;\n}\n\n.navIssue {\n  color: var(--text-strong);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ─── Main content area ─── */\n\n.layout {\n  display: flex;\n  max-width: 1060px;\n  margin: 0 auto;\n  height: calc(100vh - 44px);\n  overflow: hidden;\n}\n\n.container {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\noverflow-y: auto;\n  padding: 32px 40px 64px;\n\n  @media (max-width: 800px) {\n    height: auto;\n    overflow: auto;\n    padding: 24px 20px 48px;\n  }\n}\n\n/* ─── Properties sidebar ─── */\n\n.sidebar {\n  width: 260px;\n  flex-shrink: 0;\n  height: 100%;\n  border-left: 1px solid var(--border-subtle);\n  padding: 32px 24px 48px;\n\n  @media (max-width: 860px) {\n    display: none;\n  }\n}\n\n.sidebarGroup {\n  margin-bottom: 24px;\n}\n\n.sidebarGroupTitle {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-faint);\n  margin-bottom: 12px;\n}\n\n.propertyList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.propertyRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n}\n\n.propertyIcon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.propertyValue {\n  color: var(--text-strong);\n}\n\n.propertyMuted {\n  color: var(--text-faint);\n}\n\n.labelList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.labelChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-strong);\n  background: var(--fill-default);\n  border: 1px solid var(--border-default);\n  border-radius: 12px;\n  padding: 3px 10px 3px 7px;\n}\n\n.labelDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* ─── Issue header ─── */\n\n.issueHeader {\n  margin-bottom: 24px;\n}\n\n.identifierRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.identifier {\n  font-size: 13px;\n  color: var(--text-tertiary);\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n.stateBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-muted);\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--fill-default);\n}\n\n.stateDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.issueTitle {\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--text-heading);\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.metaRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-top: 14px;\n  font-size: 12px;\n  color: var(--text-faint);\n}\n\n.metaItem {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* ─── Sections ─── */\n\n.divider {\n  border: 0;\n  border-top: 1px solid var(--border-subtle);\n  margin: 0;\n}\n\n.section {\n  padding: 24px 0;\n}\n\n.sectionLabel {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-faint);\n  margin-bottom: 16px;\n}\n\n/* ─── Description (markdown body) ─── */\n\n.description {\n  font-size: 14px;\n  line-height: 1.7;\n  color: var(--text-body);\n\n  p {\n    margin: 0 0 0.75em;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  strong {\n    color: var(--text-heading);\n    font-weight: 600;\n  }\n\n  ul,\n  ol {\n    margin: 0.5em 0 0.75em 1.4em;\n    padding: 0;\n  }\n\n  li {\n    margin: 0.2em 0;\n  }\n\n  a {\n    color: var(--color-link);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid var(--border-default);\n    margin: 1em 0;\n  }\n\n  blockquote {\n    margin: 0.75em 0;\n    padding: 0 0 0 12px;\n    border-left: 3px solid var(--border-medium);\n    color: var(--text-secondary);\n  }\n\n  code {\n    font-family:\n      ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Monaco, Consolas,\n      monospace;\n    font-size: 0.9em;\n    background: var(--fill-default);\n    border: 1px solid var(--border-default);\n    padding: 0.15em 0.35em;\n    border-radius: 4px;\n    color: var(--text-strong);\n  }\n\n  pre {\n    margin: 0.75em 0;\n    border-radius: 6px;\n    overflow-x: auto;\n    white-space: pre;\n\n    code {\n      background: transparent;\n      border: none;\n      padding: 0;\n      font-size: 13px;\n      color: var(--text-body);\n    }\n  }\n\n  img {\n    display: block;\n    max-width: 100%;\n    max-height: 60vh;\n    border-radius: 6px;\n    margin: 0.5em auto;\n    object-fit: contain;\n    cursor: pointer;\n    transition: opacity 0.15s;\n\n    &:hover {\n      opacity: 0.85;\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: var(--text-heading);\n    margin: 1.2em 0 0.4em;\n    line-height: 1.3;\n  }\n\n  h1 {\n    font-size: 1.3em;\n  }\n  h2 {\n    font-size: 1.15em;\n  }\n  h3 {\n    font-size: 1.05em;\n  }\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0.75em 0;\n    font-size: 13px;\n\n    th,\n    td {\n      padding: 6px 10px;\n      border: 1px solid var(--border-default);\n      text-align: left;\n    }\n\n    th {\n      background: var(--fill-subtle);\n      font-weight: 600;\n      color: var(--text-muted);\n    }\n  }\n}\n\n.emptyState {\n  color: var(--text-faint);\n  font-size: 14px;\n}\n\n/* ─── Comments ─── */\n\n.comments {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.comment {\n  padding: 16px 0;\n  border-bottom: 1px solid var(--border-subtle);\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.commentHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.commentAvatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--fill-active);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.commentAuthor {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.commentTime {\n  font-size: 12px;\n  color: var(--text-faint);\n  margin-left: auto;\n}\n\n.commentBody {\n  font-size: 14px;\n  line-height: 1.7;\n  color: var(--text-body);\n  padding-left: 34px;\n\n  p {\n    margin: 0 0 0.5em;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: var(--color-link);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  code {\n    font-family:\n      ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Monaco, Consolas,\n      monospace;\n    font-size: 0.9em;\n    background: var(--fill-default);\n    border: 1px solid var(--border-default);\n    padding: 0.15em 0.35em;\n    border-radius: 4px;\n  }\n\n  pre {\n    margin: 0.5em 0;\n    padding: 12px 16px;\n    background: var(--bg-code-block);\n    border: 1px solid var(--border-subtle);\n    border-radius: 6px;\n    overflow-x: auto;\n\n    code {\n      background: transparent;\n      border: none;\n      padding: 0;\n      font-size: 13px;\n    }\n  }\n\n  blockquote {\n    margin: 0.5em 0;\n    padding-left: 12px;\n    border-left: 3px solid var(--border-medium);\n    color: var(--text-secondary);\n  }\n\n  img {\n    display: block;\n    max-width: 100%;\n    max-height: 60vh;\n    border-radius: 6px;\n    margin: 0.5em auto;\n    object-fit: contain;\n    cursor: pointer;\n    transition: opacity 0.15s;\n\n    &:hover {\n      opacity: 0.85;\n    }\n  }\n}\n\n.composer {\n  margin-top: 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.composerInput {\n  align-self: stretch;\n  width: 100%;\n  resize: none;\n  min-height: 80px;\n  background: var(--fill-default);\n  border: none;\n  border-radius: 10px;\n  padding: 12px;\n  color: var(--text-strong);\n  font-size: 14px;\n  outline: none;\n  margin-bottom: 10px;\n}\n\n.composerInput:focus {\n  box-shadow: 0 0 0 1px var(--border-strong) inset;\n}\n\n/* ─── Image lightbox ─── */\n\n.lightboxOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: var(--bg-lightbox);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: zoom-out;\n  animation: fadeIn 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.lightboxContent {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.lightboxImg {\n  max-width: 94vw;\n  max-height: 94vh;\n  object-fit: contain;\n  border-radius: 6px;\n  user-select: none;\n  -webkit-user-drag: none;\n  transform-origin: center center;\n  transition: transform 0.15s ease-out;\n  cursor: grab;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.lightboxClose {\n  position: fixed;\n  top: 16px;\n  right: 20px;\n  z-index: 110;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--fill-active);\n  color: var(--text-strong);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n\n  &:hover {\n    background: var(--border-focus);\n  }\n}\n\n.lightboxZoomHint {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 110;\n  font-size: 12px;\n  color: var(--text-faint);\n  background: var(--bg-backdrop);\n  padding: 6px 14px;\n  border-radius: 20px;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n/* ─── Loading & error states ─── */\n\n.loadingPage {\n  min-height: 100vh;\n  background: var(--bg-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 2.5px solid var(--border-default);\n  border-radius: 50%;\n  border-top-color: var(--color-link);\n  animation: spin 0.9s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorPage {\n  min-height: 100vh;\n  background: var(--bg-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-tertiary);\n  font-size: 14px;\n  font-family:\n    \"Inter\",\n    ui-sans-serif,\n    system-ui,\n    -apple-system,\n    sans-serif;\n  padding: 24px;\n  text-align: center;\n}\n\n.errorBox {\n  max-width: 400px;\n}\n\n.errorIcon {\n  font-size: 32px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.errorText {\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `shareIssue_page__38TEH`,
	"navbar": `shareIssue_navbar__8+j+y`,
	"navTeam": `shareIssue_navTeam__iE2sb`,
	"navTeamIcon": `shareIssue_navTeamIcon__fMOAd`,
	"navSep": `shareIssue_navSep__Tc7Nd`,
	"navIssue": `shareIssue_navIssue__Pzd3h`,
	"layout": `shareIssue_layout__-zE+S`,
	"container": `shareIssue_container__x2NPe`,
	"sidebar": `shareIssue_sidebar__xhTqF`,
	"sidebarGroup": `shareIssue_sidebarGroup__j3iW-`,
	"sidebarGroupTitle": `shareIssue_sidebarGroupTitle__dQJAj`,
	"propertyList": `shareIssue_propertyList__FL+0J`,
	"propertyRow": `shareIssue_propertyRow__D71pa`,
	"propertyIcon": `shareIssue_propertyIcon__tRbg8`,
	"propertyValue": `shareIssue_propertyValue__ncMOJ`,
	"propertyMuted": `shareIssue_propertyMuted__F-xjX`,
	"labelList": `shareIssue_labelList__wIaFv`,
	"labelChip": `shareIssue_labelChip__muz+j`,
	"labelDot": `shareIssue_labelDot__ZJdbs`,
	"issueHeader": `shareIssue_issueHeader__nU1xQ`,
	"identifierRow": `shareIssue_identifierRow__I4fOT`,
	"identifier": `shareIssue_identifier__R6QsN`,
	"stateBadge": `shareIssue_stateBadge__VnQ50`,
	"stateDot": `shareIssue_stateDot__JIZaN`,
	"issueTitle": `shareIssue_issueTitle__WFekp`,
	"metaRow": `shareIssue_metaRow__845YN`,
	"metaItem": `shareIssue_metaItem__4HwQ3`,
	"divider": `shareIssue_divider__4QlJx`,
	"section": `shareIssue_section__R5CCQ`,
	"sectionLabel": `shareIssue_sectionLabel__pqD3M`,
	"description": `shareIssue_description__OGKiq`,
	"emptyState": `shareIssue_emptyState__eTzdk`,
	"comments": `shareIssue_comments__FW7kb`,
	"comment": `shareIssue_comment__4hbU7`,
	"commentHeader": `shareIssue_commentHeader__r7xC6`,
	"commentAvatar": `shareIssue_commentAvatar__xORY3`,
	"commentAuthor": `shareIssue_commentAuthor__JGZbT`,
	"commentTime": `shareIssue_commentTime__3iDF6`,
	"commentBody": `shareIssue_commentBody__QtY2V`,
	"composer": `shareIssue_composer__ySU-N`,
	"composerInput": `shareIssue_composerInput__NOZfz`,
	"lightboxOverlay": `shareIssue_lightboxOverlay__6frl3`,
	"fadeIn": `shareIssue_fadeIn__2Bib2`,
	"lightboxContent": `shareIssue_lightboxContent__xpZZF`,
	"lightboxImg": `shareIssue_lightboxImg__eVxVR`,
	"lightboxClose": `shareIssue_lightboxClose__Ca2Dy`,
	"lightboxZoomHint": `shareIssue_lightboxZoomHint__7Rztp`,
	"loadingPage": `shareIssue_loadingPage__ix3kn`,
	"spinner": `shareIssue_spinner__cA47q`,
	"spin": `shareIssue_spin__HVGP3`,
	"errorPage": `shareIssue_errorPage__-aZh0`,
	"errorBox": `shareIssue_errorBox__WdjSG`,
	"errorIcon": `shareIssue_errorIcon__X9H45`,
	"errorText": `shareIssue_errorText__6HJvo`
};
export default ___CSS_LOADER_EXPORT___;
